import React from "react";
import { MDBCol, MDBRadio, MDBRow } from "mdb-react-ui-kit";
import ReactDatePicker from "react-datepicker";
import moment from "moment";
import { shallow } from "zustand/shallow";
import styles from "@/styles/userPage/userPage.module.scss";
import { chekStartOrEndWithSpace, isValidWithoutSpace } from "@/utils/common";
import { EGender } from "@/models/common/enums";
import { useStore } from "@/store/index";
import { IUser } from "@/models/user";
import AddressGoogle from "@/components/checkout/AddressGoogle";
import ReactFlagsSelect from "react-flags-select";
import Input from "../../common/Input";
import DatePickerButton from "../../common/DatePickerButton";

const GeneralInfo = () => {
    const {
        birthDate,
        gender,
        cityOfBirth,
        taxIdCode,
        address,
        language,
        city,
        country,
        zipCode,
        county,
    } = useStore(
        state => ({
            birthDate: state.userState.userDetail.birthDate,
            gender: state.userState.userDetail.gender,
            cityOfBirth: state.userState.userDetail.cityOfBirth,
            city: state.userState.userDetail.city,
            taxIdCode: state.userState.userDetail.taxIdCode,
            address: state.userState.userDetail.address,
            language: state.userState.userDetail.language,
            country: state.userState.userDetail.country,
            county: state.userState.userDetail.county,
            zipCode: state.userState.userDetail.zipCode,
        }),
        shallow
    );

    const dispatch = useStore(state => state.dispatchUser);
    // const dispatchCheckout = useStore(state => state.dispatchCheckout);

    const languages: { id: string; name: string }[] = [
        {
            id: "1",
            name: "Italiano",
        },
        {
            id: "2",
            name: "English",
        },
        {
            id: "3",
            name: "Français",
        },
        {
            id: "4",
            name: "Español",
        },
        {
            id: "5",
            name: "Deutsch",
        },
    ];

    const checkGender = (el: EGender) => {
        return gender === el;
    };

    const onChangeGender = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target as never;
        const selectedName = (name as string).toLowerCase().includes("gender")
            ? "gender"
            : name;

        dispatch({
            type: "UPDATE_USER_DETAIL",
            payload: { [selectedName]: value },
        });
    };

    const onChange = (e: {
        stopPropagation: () => void;
        preventDefault: () => void;
        target: {
            name: keyof IUser;
            value: unknown;
        };
    }) => {
        e.stopPropagation();
        e.preventDefault();

        const { name, value } = e.target;

        dispatch({
            type: "UPDATE_USER_DETAIL",
            payload: { [name]: value },
        });
    };

    const setAddressValue = (
        addressText: { offset: number; value: string }[],
        addressValue: string
    ) => {
        dispatch({
            type: "SET_USER_ADDRESS",
            payload: { address: addressText, addressValue },
        });
    };

    return (
        <div>
            <p className={styles.title}>General Info</p>
            <MDBRow>
                <MDBCol size={12} xl={6} className="my-2 ">
                    <p className={styles.labelForm}>GENDER*</p>
                    <div>
                        <MDBRadio
                            name="gender male"
                            id={`${EGender.MALE} male`}
                            value={EGender.MALE}
                            label={<span>{EGender.MALE}</span>}
                            className="PICustomCheckbox"
                            checked={checkGender(EGender.MALE)}
                            onChange={onChangeGender}
                            inline
                        />
                        <MDBRadio
                            name="gender female"
                            id={`${EGender.FEMALE} female`}
                            value={EGender.FEMALE}
                            label={<span>{EGender.FEMALE}</span>}
                            className="PICustomCheckbox"
                            checked={checkGender(EGender.FEMALE)}
                            onChange={onChangeGender}
                            inline
                        />
                        <MDBRadio
                            name="gender other"
                            id={`${EGender.OTHER} other`}
                            value={EGender.OTHER}
                            label={<span>{EGender.OTHER}</span>}
                            className="PICustomCheckbox"
                            checked={
                                gender === EGender.NONE
                                    ? true
                                    : checkGender(EGender.OTHER)
                            }
                            onChange={onChangeGender}
                            inline
                        />
                    </div>
                </MDBCol>

                <MDBCol size={12} xl={6} className="my-2">
                    <p className={styles.labelForm}>DATE OF BIRTH*</p>
                    <ReactDatePicker
                        selected={birthDate ? new Date(birthDate) : null}
                        onChange={date => {
                            dispatch({
                                type: "UPDATE_USER_DETAIL",
                                payload: { birthDate: moment(date).format() },
                            });
                        }}
                        maxDate={moment().subtract(18, "years").toDate()}
                        customInput={<DatePickerButton requiredValue />}
                        showYearDropdown
                        showMonthDropdown
                        dropdownMode="select"
                        yearDropdownItemNumber={15}
                        dateFormat="MMMM d, yyyy"
                        disabledKeyboardNavigation
                        withPortal
                    />
                </MDBCol>
            </MDBRow>

            <MDBRow>
                <Input
                    type="text"
                    columnProps={{ size: 12, xl: 6, className: "my-2" }}
                    label="CITY OF BIRTH"
                    required
                    name="cityOfBirth"
                    id="cityOfBirth"
                    value={cityOfBirth}
                    onChange={onChange as never}
                    validationCb={val => chekStartOrEndWithSpace(val as string)}
                />

                <Input
                    type="text"
                    columnProps={{ size: 12, xl: 6, className: "my-2" }}
                    onChange={onChange as never}
                    label="VAT NUMBER/FISCAL CODE/SSN"
                    name="taxIdCode"
                    id="taxCode"
                    required
                    value={taxIdCode}
                    validationCb={val => isValidWithoutSpace(val as string)}
                />
            </MDBRow>
            <MDBRow>
                {/* <Input
                    type="text"
                    columnProps={{ size: 12, className: "my-2" }}
                    onChange={onChange as never}
                    label="ADDRESS"
                    name="address"
                    id="address"
                    required
                    value={address}
                    validationCb={val => chekStartOrEndWithSpace(val as string)}
                /> */}
                <MDBCol size={12} className="">
                    <span
                        style={{
                            fontFamily: "GeneralSans-Regular",
                            marginBottom: "0.5rem",
                            fontSize: "12px",
                            color: "#777e91",
                        }}
                    >
                        STREET*
                    </span>
                    <AddressGoogle
                        value={address ?? ""}
                        setValue={setAddressValue}
                    />
                </MDBCol>

                <Input
                    type="text"
                    columnProps={{ size: 12, className: "my-2" }}
                    onChange={onChange as never}
                    label="POSTAL CODE"
                    name="zipCode"
                    id="zipCode"
                    required
                    value={zipCode}
                    // validationCb={val => chekStartOrEndWithSpace(val as string)}
                />

                <Input
                    type="text"
                    columnProps={{ size: 12, className: "my-2" }}
                    onChange={onChange as never}
                    label="CITY"
                    name="city"
                    id="city"
                    required
                    value={city}
                    validationCb={val => chekStartOrEndWithSpace(val as string)}
                />

                <Input
                    type="text"
                    columnProps={{ size: 12, className: "my-2" }}
                    onChange={onChange as never}
                    label="STATE"
                    name="county"
                    id="county"
                    value={county}
                    // validationCb={val => chekStartOrEndWithSpace(val as string)}
                />

                <MDBCol size={12} xl={12}>
                    <div
                        style={{
                            fontFamily: "GeneralSans-Regular",
                            marginBottom: "0.5rem",
                            fontSize: "12px",
                            fontWeight: "400",
                            color: "#777e91",
                        }}
                    >
                        NATIONALITY*
                    </div>
                    <ReactFlagsSelect
                        selected={country || "IT"}
                        onSelect={code => {
                            dispatch({
                                type: "UPDATE_USER_DETAIL",
                                payload: { country: code },
                            });
                        }}
                    />
                </MDBCol>

                <Input
                    type="select"
                    columnProps={{ size: 12, className: "my-3" }}
                    onChangeSelect={onChange as never}
                    name="language"
                    id="language"
                    label="LANGUAGE"
                    required
                    value={language?.toLowerCase()}
                    options={[
                        { value: "", label: "Select your Language" },
                        ...languages.map(lang => ({
                            value: lang.name?.toLowerCase(),
                            label: lang.name,
                        })),
                    ]}
                />
                {/* 
                <Input
                    type="text"
                    columnProps={{ size: 12, className: "my-2" }}
                    onChange={onChange as never}
                    label="COUNTRY"
                    name="country"
                    id="country"
                    required
                    value={country}
                    validationCb={val => chekStartOrEndWithSpace(val as string)}
                /> */}
            </MDBRow>
        </div>
    );
};

export default GeneralInfo;
